import {
  ROUTE_API_MANAGEMENT_ROOT,
  ROUTE_SEARCH_ROOT,
  ROUTE_SETTING_ROOT,
  SHARED_ROUTES,
} from '@aibees/shared/constants';

const SEARCH_LIST_ROOT = `/search-list`;
const BUYING_TEAM_ROOT = `/buying-team`;
const BACK_OFFICE_ROOT = `/back-office`;
export const COMPANY_ROOT = '/company';
export const PEOPLE_ROOT = '/people';
export const ROUTE_PLUG_IN_ROOT = '/plug-in';

export const ROUTES = {
  ...SHARED_ROUTES,
  developer: `${ROUTE_SETTING_ROOT}/developer`,

  // ******wordpress redirects*******
  signup: '/signup',

  // ******search*******
  searchCompany: `${ROUTE_SEARCH_ROOT}/company`,
  searchPeople: `${ROUTE_SEARCH_ROOT}/people`,

  // ******search list*******
  searchList: SEARCH_LIST_ROOT,
  searchListSavedCompany: `${SEARCH_LIST_ROOT}/saved-company`,
  searchListSavedPeople: `${SEARCH_LIST_ROOT}/saved-people`,

  buyingTeamPage: BUYING_TEAM_ROOT,

  // ******backoffice*******
  backofficeRoot: `${ROUTE_SETTING_ROOT}${BACK_OFFICE_ROOT}`,
  backofficeAccountManagement: `${ROUTE_SETTING_ROOT}${BACK_OFFICE_ROOT}/account-management`,
  backofficeAccountStats: `${ROUTE_SETTING_ROOT}${BACK_OFFICE_ROOT}/account-stats`,
  backofficeFinancialStats: `${ROUTE_SETTING_ROOT}${BACK_OFFICE_ROOT}/financial-stats`,

  // ******plug-in*******
  plugInPage: `${ROUTE_SETTING_ROOT}${ROUTE_PLUG_IN_ROOT}`,
  integrationPage: `${ROUTE_SETTING_ROOT}${ROUTE_PLUG_IN_ROOT}/integration`,

  // ******company*******
  companyRoot: COMPANY_ROOT,
  company: `${COMPANY_ROOT}/:id`,
  companyEmployees: `${COMPANY_ROOT}/:id/employees`,
  companyLookalike: `${COMPANY_ROOT}/:id/lookalike`,

  // ******people*******
  peopleRoot: PEOPLE_ROOT,
  people: `${PEOPLE_ROOT}/:id`,
  peoplePersonalityAnalysis: `${PEOPLE_ROOT}/:id/personality-analysis`,
  peopleUpdates: `${PEOPLE_ROOT}/:id/updates`,
  peopleUpdatesProfile: `${PEOPLE_ROOT}/:id/updates/profile`,
  peopleUpdatesContact: `${PEOPLE_ROOT}/:id/updates/contact`,
  peopleUpdatesAnalysis: `${PEOPLE_ROOT}/:id/updates/analysis`,
  peopleLookalike: `${PEOPLE_ROOT}/:id/lookalike`,

  // ******charts*******
  chart: '/charts-preview',

  // ******api-management*******
  apiManagementRoot: `${ROUTE_SETTING_ROOT}/${ROUTE_API_MANAGEMENT_ROOT}`,
  apiManagementDashboard: `${ROUTE_SETTING_ROOT}/${ROUTE_API_MANAGEMENT_ROOT}/dashboard`,
  apiManagementApiKeys: `${ROUTE_SETTING_ROOT}/${ROUTE_API_MANAGEMENT_ROOT}/api-keys`,

  // ******theme preview*******
  themePreview: '/theme-preview',
};
